{
  "name": "Baby Every Agent",
  "handle": "baby-every",
  "parent_name": "Every",
  "stage_label": "Test env",
  "tagline": "The smaller, cheekier sibling of Every's Slack agent. It turns the work your team repeats into Slack workflows, and your workspace into the test env.",
  "brand": {
    "theme_color": "#1500ff",
    "background_color": "#faf8f5"
  }
}
